import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Janus } from './janus';
import { changeJanusStatus, swapServers, setJanusDTMF, setJanusStarted } from '../redux/parametersSlice';
import SignalRService from 'src/controllers/SignalRService';

class WebPhony extends Component {

    constructor(props) {

        super();
        this.janus = null;
        this.janusStarted = false;
        this.janusMuteState = false;
        this.initialized = false;
        this.state = {
            audio: null,
            phoneStatus: {}
        };
        this.audioRef = React.createRef();
        this.onAudioStream = this.onAudioStream.bind(this);
        this.success = this.success.bind(this);
        this.webphony = null;
        this.sessionId = null;
        this.startJanus = this.startJanus.bind(this);
        this.setCtiEvent = this.setCtiEvent.bind(this);
        this.beforeunloadDestroy = this.beforeunloadDestroy.bind(this);
        this.startJanusDate = null;

        this.sdpSentEvent = this.sdpSentEvent.bind(this);
        this.restartJanus = this.restartJanus.bind(this);

        SignalRService.registerCTIEvent(this.setCtiEvent);

        this.sdpSent = false;
    }

    componentDidMount() {
        window.addEventListener("beforeunload", this.beforeunloadDestroy);
        document.addEventListener('sdpSent', this.sdpSentEvent);
    }

    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.beforeunloadDestroy);
        document.removeEventListener('sdpSent', this.handleConnectionLost);
    }

    sdpSentEvent = () => {
        console.log('Webphony: SDP WAS SENT.');
        this.sdpSent = true;
    }

    beforeunloadDestroy = () => {
        if (this.janusStarted) {
            this.janus.destroy();
            SignalRService.hangup({
                "extension": this.props.extension,
                "userId": this.props.userId
            });
        }
    }

    setCtiEvent = (ev) => {
        this.setState({
            phoneStatus: ev
        })
    }

    onAudioStream = (stream) => {
        Janus.debug(" ::: Got a remote stream :::");
        Janus.debug(JSON.stringify(stream));
        this.setState({
            audio: stream
        });
    }

    success = (pluginHandle) => {
        this.webphony = pluginHandle;
        this.sessionId = this.webphony.getId();
        Janus.log("Plugin attached! (" + this.webphony.getPlugin() + ", id=" + this.sessionId + ")");

        let message = {
            extension: localStorage.getItem("faExtension"),
            userId: parseInt(localStorage.getItem("faUserId")),
            message: "success sessionId: " + this.sessionId + ", codec: " + this.props.janusCodec + ", record: " + this.props.functions.recordAnyway
        };

        SignalRService.janusLog(message);

        let body = { "audio": true, "video": false, "webphonycodec": this.props.janusCodec, "record": this.props.functions.recordAnyway, "filename": "jwp-" + this.sessionId };
        Janus.debug("Sending message (" + JSON.stringify(body) + ")");
        this.webphony.send({ "message": body });
        Janus.debug("Trying a createOffer too (audio sendrecv)");

        this.webphony.createOffer(
            {
                media: { data: false },
                success: function (jsep) {
                    Janus.debug("Got SDP!");
                    Janus.debug(jsep);
                    pluginHandle.send({ "message": body, "jsep": jsep });
                },
                error: function (error) {
                    Janus.error("WebRTC error:", error);
                }
            });
    }

    onMessage = (msg, jsep) => {
        Janus.debug(" ::: Got a message :::");
        Janus.debug(JSON.stringify(msg));
        let event = new CustomEvent("janusMessage", { detail: msg })
        document.dispatchEvent(event);
        if (jsep !== undefined && jsep !== null) {
            Janus.debug("Handling SDP as well...");
            Janus.debug(jsep);
            this.webphony.handleRemoteJsep({ jsep: jsep });
        }
    }

    attach = () => {

        this.janus.attach({
            plugin: "janus.plugin.webphony",
            success: this.success,
            onmessage: this.onMessage,
            onremotestream: this.onAudioStream,
            error: function (error) {
                console.error("  -- Error attaching plugin...", error);

                let message = {
                    extension: localStorage.getItem("faExtension"),
                    userId: parseInt(localStorage.getItem("faUserId")),
                    message: "error: " + error
                };

                SignalRService.janusLog(message);
            },
            iceState: function (state) {
                Janus.log("ICE state changed to " + state);

                let message = {
                    extension: localStorage.getItem("faExtension"),
                    userId: parseInt(localStorage.getItem("faUserId")),
                    message: "iceState: " + state
                };

                SignalRService.janusLog(message);
            },
            mediaState: function (medium, on) {
                Janus.log("Janus " + (on ? "started" : "stopped") + " receiving our " + medium);

                let message = {
                    extension: localStorage.getItem("faExtension"),
                    userId: parseInt(localStorage.getItem("faUserId")),
                    message: "mediaState: " + (on ? "started" : "stopped")
                };

                SignalRService.janusLog(message);
            },
            webrtcState: function (on) {
                Janus.log("Janus says our WebRTC PeerConnection is " + (on ? "up" : "down") + " now");

                let message = {
                    extension: localStorage.getItem("faExtension"),
                    userId: parseInt(localStorage.getItem("faUserId")),
                    message: "webrtcState: " + (on ? "up" : "down")
                };

                SignalRService.janusLog(message);
            },
            slowLink: function (uplink, nacks) {
                Janus.warn("Janus reports problems " + (uplink ? "sending" : "receiving") +
                    " packets on this PeerConnection (" + nacks + " NACKs/s " + (uplink ? "received" : "sent") + ")");
            },
            oncleanup: function () {
                Janus.log(" ::: Got a cleanup notification :::");
            }
        });
    }

    error = (error) => {
        Janus.error(error);
        this.props.setJanusStarted(false);
        if (this.janusStarted) {
            console.log(">>>>>>>JANUS: DESTROY")
            this.janus.destroy();
            this.janusStarted = false;
            this.props.setJanusStarted(false);
            this.props.changeJanusStatus("");
        }
    }

    startJanus = async () => {
        console.log('>>>>>>>JANUS: STARTING JANUS');
        if (this.props.janusPrivate.length < 15)
            return;

        this.sdpSent = false;
        // Deberes video llamada
        // if (isWebRTC)
        //     return;
        if (this.janusStarted)
            this.janus.destroy();

        let message = {
            extension: localStorage.getItem("faExtension"),
            userId: parseInt(localStorage.getItem("faUserId")),
            message: "startJanus server: " + this.props.janusPrivate
        };

        SignalRService.janusLog(message);

        this.janusStarted = true;
        this.janusMuteState = false;
        if (!Janus.isWebrtcSupported()) {
            console.error("No WebRTC support... ");
            return;
        }

        this.props.changeJanusStatus("");
        this.props.setJanusStarted(true);
        setTimeout(this.restartJanus, 4000);

        this.janus = new Janus({
            server: [this.props.janusPrivate, this.props.janusSupportPrivate],
            swapServers: this.props.swapServers,
            success: this.attach,
            error: this.error
        });
    }

    restartJanus() {
        if (!this.sdpSent) {
            console.log('>>>>>>>JANUS: SDP WAS NOT SENT.... \n RESTARTING JANUS');

            let message = {
                extension: localStorage.getItem("faExtension"),
                userId: parseInt(localStorage.getItem("faUserId")),
                message: "restartJanus"
            };

            SignalRService.janusLog(message);

            this.startJanus();
        } else {
            console.log('>>>>>>>JANUS: SDP SENT SUCCESSFULLY');
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.state.phoneStatus.isWebRTC) {
            console.log(">>>>>>>JANUS: " + this.props.janusStatus)

            if (!this.initialized) {
                this.initialized = true;
                Janus.init({ debug: "all" });
            }

            if (this.props.janusStatus === "inboundCall") {
                this.startJanus();
            }

            if (!this.janusStarted && this.props.janusStatus === "makeCall" && prevState.phoneStatus.ctiStatus !== 'TALKING' && prevState.phoneStatus.ctiStatus !== 'HELD') {
                this.startJanus();
            }

            if (this.props.janusStatus === "mute") {

                let message = {
                    extension: localStorage.getItem("faExtension"),
                    userId: parseInt(localStorage.getItem("faUserId")),
                    message: "audio: false"
                };

                SignalRService.janusLog(message);

                this.webphony.send({ "message": { "audio": false } });
            }

            if (this.props.janusStatus === "unmute") {

                let message = {
                    extension: localStorage.getItem("faExtension"),
                    userId: parseInt(localStorage.getItem("faUserId")),
                    message: "audio: true"
                };

                SignalRService.janusLog(message);

                this.webphony.send({ "message": { "audio": true } });
            }

            if (this.props.janusStatus === "startRecording" ||
                (this.state.phoneStatus.janusGroupRecord && !prevState.phoneStatus.janusGroupRecord)) {
                
                let message = {
                    extension: localStorage.getItem("faExtension"),
                    userId: parseInt(localStorage.getItem("faUserId")),
                    message: "record: true"
                };

                SignalRService.janusLog(message);

                this.webphony.send({ "message": { "record": true, "filename": "jwp-" + this.webphony.getId() } });
            }

            if (this.props.janusStatus === "stopRecording") {

                let message = {
                    extension: localStorage.getItem("faExtension"),
                    userId: parseInt(localStorage.getItem("faUserId")),
                    message: "record: false"
                };

                SignalRService.janusLog(message);

                this.webphony.send({ "message": { "record": false } });
            }

            if (this.props.janusStatus === "pauseRecording") {

                let message = {
                    extension: localStorage.getItem("faExtension"),
                    userId: parseInt(localStorage.getItem("faUserId")),
                    message: "recmute: true"
                };

                SignalRService.janusLog(message);

                this.webphony.send({ "message": { "recmute": true } });
            }

            if (this.props.janusStatus === "resumeRecording") {

                let message = {
                    extension: localStorage.getItem("faExtension"),
                    userId: parseInt(localStorage.getItem("faUserId")),
                    message: "recmute: false"
                };

                SignalRService.janusLog(message);

                this.webphony.send({ "message": { "recmute": false } });
            }

            //console.log("HANGUP COUNTER: " + this.state.phoneStatus.hungUpCounter + ">" + prevState.phoneStatus.hungUpCounter)
            if (this.janus && this.state.phoneStatus && prevState.phoneStatus && (
                (this.state.phoneStatus.hungUpCounter > prevState.phoneStatus.hungUpCounter) ||
                (prevState.phoneStatus.ctiStatus !== 'HUNGUP' && this.state.phoneStatus.ctiStatus === 'HUNGUP') ||
                (prevState.phoneStatus.ctiStatus !== 'BUSY' && this.state.phoneStatus.ctiStatus === 'BUSY' && this.state.phoneStatus.heldCallGUID === null)
            )) {

                if (this.janusStarted) {
                    console.log(">>>>>>>JANUS: DESTROY");
                    this.janus.destroy();
                    this.janusStarted = false;

                    let message = {
                        extension: localStorage.getItem("faExtension"),
                        userId: parseInt(localStorage.getItem("faUserId")),
                        message: "destroyJanus"
                    };

                    SignalRService.janusLog(message);

                    this.props.setJanusStarted(false);
                    this.props.changeJanusStatus("");
                    let ring = null;
                    ring = document.createElement('audio');
                    ring.src = 'mp3/hungup.mp3';
                    ring.preload = 'auto';

                    ring.loop = false;
                    ring.load();
                    ring.play();
                }
            }

            if (this.state.audio && !this.state.phoneStatus.isWebRTC) {
                Janus.attachMediaStream(this.audioRef.current, this.state.audio);
            }

            if (this.state.phoneStatus.ctiStatus === "TALKING" && this.props.janusDTMF != null && this.props.janusDTMF.trim() !== "") {
                let tones = this.props.janusDTMF;
                this.props.setJanusDTMF("");

                let message = {
                    extension: localStorage.getItem("faExtension"),
                    userId: parseInt(localStorage.getItem("faUserId")),
                    message: "dtmf: " + tones
                };

                SignalRService.janusLog(message);

                this.webphony.dtmf({
                    "dtmf": { "tones": tones },
                    "success": function (jsep) {
                        console.info("Got DTMF!");
                    },
                    "error": function (error) {
                        console.error("WebRTC DTMF error:", error);
                    }
                });
            }
        }
    }

    render() {
        return (<audio loop={false} autoPlay={true} ref={this.audioRef}><source src=''></source></audio>);
    };

}

const mapStateToProps = (state) => {
    return {
        janusPrivate: state.parameters.janusPrivate,
        janusPublic: state.parameters.janusPublic,
        janusSupportPrivate: state.parameters.janusSupportPrivate,
        janusSupportPublic: state.parameters.janusSupportPublic,
        janusCodec: state.parameters.janusCodec,
        janusAgent: state.parameters.janusAgent,
        extension: state.agent.extension,
        userId: state.agent.userId,
        functions: state.agent.functions,
        current: state.interaction.current,
        janusStatus: state.parameters.janusStatus,
        janusDTMF: state.parameters.janusDTMF
    };
};

export default compose(connect(mapStateToProps, { changeJanusStatus, swapServers, setJanusDTMF, setJanusStarted }))(WebPhony);